import { render, staticRenderFns } from "./StockQuote.vue?vue&type=template&id=ba8b3be8&scoped=true&"
import script from "./StockQuote.vue?vue&type=script&lang=js&"
export * from "./StockQuote.vue?vue&type=script&lang=js&"
import style0 from "./StockQuote.vue?vue&type=style&index=0&id=ba8b3be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b3be8",
  null
  
)

export default component.exports